(($) => {

    /**
     * hide those status fields that are currently not needed
     */
    const updateStatusFields = () => {
        const statusReasonElement = $('#changeStatusReason');
        const statusOtherCommentListItem = $('#changeStatusOtherComment').closest('li');
        if (+$('#changeStatus').find('option:selected').attr('value') < $('#changeStatus option').length -1) {
            // first select is not at the last option: hide other fields
            statusReasonElement.closest('li').hide();
            statusOtherCommentListItem.hide();
            return;
        }
        // first value is the last option: show second select
        statusReasonElement.closest('li').show();
        if (+statusReasonElement.find('option:selected').attr('value') < $('#changeStatusReason option').length -1) {
            // second select is not at the last option: hide comment field
            statusOtherCommentListItem.hide();
            return;
        }
        // second select is at the last option: show comment field
        statusOtherCommentListItem.show();
    }

    const updateOpportunityStatus = (opportunity) => {
        // get controller URL from form action
        const url = $('#opportunityIdentity').closest('form').attr('action');
        return $.ajax({
            method: 'PATCH',
            url: url,
            data: opportunity
        }).fail(function() {
            console.log('error');
        }).always(function() {
            updateStatusFields();
        });
    }

    $(document).ready(function() {
        updateStatusFields();

        const identity = $('#opportunityIdentity').val();
        $('[name="opportunity[status]"]').on('change', (event) => {
            const formField = $(event.target);
            const newColor = formField.find('option:selected').css('color');
            updateOpportunityStatus({
                opportunity: {
                    status: formField.find('option:selected').attr('value'),
                    __identity: identity
                }
            }).done(() => {
                formField.css('color', newColor)
            });
        });

        $('[name="opportunity[statusReason]"]').on('change', (event) => {
            const formField = $(event.target);
            const newColor = formField.find('option:selected').css('color');
            updateOpportunityStatus({
                opportunity: {
                    statusReason: formField.find('option:selected').attr('value'),
                    __identity: identity
                }
            }).done(() => {
                formField.css('color', newColor)
            });
        });

        $('[name="opportunity[statusOtherComment]"]').on('change', (event) => {
            updateOpportunityStatus({
                opportunity: {
                    statusOtherComment: $(event.target).val(),
                    __identity: identity
                }
            });
        });
    });
})(jQuery);
